import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { Input } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';

const ApplyPromoCodeForm = ({ error, handleSubmit, pristine, submitting, isReadonly, t }) => {
	return <Form horizontal onSubmit={handleSubmit}>
		{error && <Alert bsStyle='danger'>{error}</Alert>}
		<Field name='promoCode' component={Input} horizontal required disabled={isReadonly} type='text' labelCol={4} valueCol={8} label={t('PaymentHistory_PromoCode')} />
	</Form>;
};

export default reduxForm({ form: 'applyPromoCode', enableReinitialize: true })(withTranslation()(ApplyPromoCodeForm));

export const selector = formValueSelector('applyPromoCode');